module["exports"] = [
  "0####-#-####",
  "0###-##-####",
  "0##-###-####",
  "0#-####-####"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ja/phone_number/formats.js
// module id = 3183
// module chunks = 1609